'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var SelectListItem = function (_PureComponent) {
  _inherits(SelectListItem, _PureComponent);

  function SelectListItem(props) {
    _classCallCheck(this, SelectListItem);

    var _this = _possibleConstructorReturn(this, (SelectListItem.__proto__ || Object.getPrototypeOf(SelectListItem)).call(this, props));

    var active = 'active' in _this.props ? Boolean(_this.props.active) : false;
    _this.state = {
      active: active
    };
    return _this;
  }

  _createClass(SelectListItem, [{
    key: 'handleListClick',
    value: function handleListClick(e) {
      //https://stackoverflow.com/questions/50819162/why-is-my-function-being-called-twice-in-react
      e.preventDefault();
      var _props = this.props,
          value = _props.value,
          showAddButton = _props.showAddButton,
          disabled = _props.disabled,
          disabledForTags = _props.disabledForTags;


      if (disabled || disabledForTags) {
        return;
      }

      if (showAddButton && e.target.className !== "a-select-list-add-button") {
        return;
      }

      if (e.target.type === 'radio') {
        return;
      }

      var active = this.state.active;
      var onSelect = this.context.selectList.onSelect;

      this.setState({
        active: !active
      });
      onSelect && onSelect(e, value);
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      if (e.keyCode === 13) {
        this.handleListClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _ClassNames;

      var _props2 = this.props,
          _props2$disabled = _props2.disabled,
          disabled = _props2$disabled === undefined ? false : _props2$disabled,
          _props2$disabledForTa = _props2.disabledForTags,
          disabledForTags = _props2$disabledForTa === undefined ? false : _props2$disabledForTa,
          style = _props2.style,
          className = _props2.className,
          subHeader = _props2.subHeader,
          children = _props2.children,
          active = _props2.active,
          showAddButton = _props2.showAddButton,
          keyboardHighlight = _props2.keyboardHighlight,
          otherProps = _objectWithoutProperties(_props2, ['disabled', 'disabledForTags', 'style', 'className', 'subHeader', 'children', 'active', 'showAddButton', 'keyboardHighlight']);

      var _active = 'active' in this.props ? Boolean(this.props.active) : Boolean(this.state.active);
      var classes = (0, _classnames2.default)(className, (_ClassNames = {}, _defineProperty(_ClassNames, 'active', !!_active && !disabled && !disabledForTags), _defineProperty(_ClassNames, "with-add-button", showAddButton), _defineProperty(_ClassNames, 'keyboardHighlight', keyboardHighlight), _ClassNames));

      if (!subHeader) {
        return _react2.default.createElement(
          'div',
          {
            onKeyDown: this.onKeyDown,
            onClick: this.handleListClick.bind(this),
            className: (0, _classnames2.default)('list-item-wrapper', {
              disabled: disabled,
              disabledForTags: disabledForTags
            }) },
          _react2.default.createElement(
            _index.ListItem,
            Object.assign({
              style: style,
              className: classes,
              subHeader: subHeader
            }, otherProps),
            children
          )
        );
      }
      return _react2.default.createElement(
        _index.ListItem,
        Object.assign({ className: classes, subHeader: subHeader }, otherProps),
        children
      );
    }
  }]);

  return SelectListItem;
}(_react.PureComponent);

SelectListItem.contextTypes = {
  selectList: _propTypes2.default.any
};


SelectListItem.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  subHeader: _propTypes2.default.bool,
  onSelect: _propTypes2.default.func,
  active: _propTypes2.default.bool,
  value: _propTypes2.default.any,
  children: _propTypes2.default.any,
  disabled: _propTypes2.default.bool,
  disabledForTags: _propTypes2.default.bool,
  showAddButton: _propTypes2.default.bool
};

SelectListItem.displayName = 'SelectListItem';

exports.default = SelectListItem;